var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{staticClass:"mt-n2 ml-n2",attrs:{"app":"","color":"secondary","value":_vm.value,"top":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"color":"white","text":""},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }